<template>
  <v-navigation-drawer id="core-navigation-drawer" dark :mini-variant.sync="drawer" :right="$vuetify.rtl"
                       :src="barImage" mobile-breakpoint="560" permanent app mini-variant-width="90" width="260" v-bind="$attrs"
                       style="-webkit-app-region: drag">
    <template v-slot:img="props">
      <v-img :gradient="`to top, ${barColor}`" v-bind="props" />
    </template>

    <v-divider class="mb-1" />

    <v-list dense nav style="-webkit-app-region: no-drag">
      <v-list-item>
        <v-list-item-avatar class="my-0">
          <v-icon>mdi-home</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            <h1>{{ storeName }}</h1>
          </v-list-item-title>
        </v-list-item-content>
        <!-- <v-list-item-avatar
          class="align-self-center"
          color="white"
          contain
        >
          <v-img
            src="https://demos.creative-tim.com/vuetify-material-dashboard/favicon.ico"
            max-height="30"
          />
        </v-list-item-avatar> -->

        <!-- <v-list-item-content>
          <v-list-item-title
            class="display-1"
            v-text="profile.title"
          />
        </v-list-item-content> -->
      </v-list-item>
    </v-list>

    <v-divider class="mb-2" />

    <v-list expand nav style="-webkit-app-region: no-drag">
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <v-list-group v-if="item.children" :key="`group-${i}`" :prepend-icon="item.icon" :group="item.group" ripple
                      active-class="colorless white--text">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title dark v-text="item.title" />
            </v-list-item-content>
          </template>
          <v-list-item v-for="(child, index) in item.children" :key="index" :to="child.to" dark
                       active-class="primary white--text">
            <v-list-item-avatar class="my-0" v-text="child.title.substr(0, 1)" />
            <v-list-item-content>
              <v-list-item-title v-text="child.title" />
            </v-list-item-content>
            <v-badge overlap color="rgba(0, 0, 0, 0)" right style="position: absolute; right: 10%; top: 35%;"
                     :value="child.title === 'Sold' && saleTempList.length">
              <template v-slot:badge>
                <v-icon>mdi-bell</v-icon>
              </template>
            </v-badge>
            <v-badge overlap color="rgba(0, 0, 0, 0)" right style="position: absolute; right: 10%; top: 35%;"
                     :value="child.title === 'Transfer' && transferUnsavedChanges">
              <template v-slot:badge>
                <v-icon>mdi-bell</v-icon>
              </template>
            </v-badge>
            <v-badge overlap color="rgba(0, 0, 0, 0)" right style="position: absolute; right: 10%; top: 35%;"
                     :value="child.title === 'Receive' && receiveUnsavedChanges">
              <template v-slot:badge>
                <v-icon>mdi-bell</v-icon>
              </template>
            </v-badge>
            <v-badge overlap icon="mdi-bell" color="rgba(0, 0, 0, 0)" right
                     style="position: absolute; right: 10%; top: 35%;"
                     :value="child.title === 'Lost' && lostTempList.length" />
            <v-badge overlap icon="mdi-bell" color="rgba(0, 0, 0, 0)" right
                     style="position: absolute; right: 10%; top: 35%;"
                     :value="child.title === 'Purchased' && recievedTempList.length" />
          </v-list-item>
        </v-list-group>
        <!-- <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        > -->
        <!--  -->
        <!-- </base-item-group> -->
        <v-list-item v-else-if="item.role === user.role" :key="`item-${item.name}`" active-class="primary" dark
                     :to="item.to">
          <v-list-item-icon><v-icon v-text="item.icon" /></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else :key="`item-${item.name}`" active-class="primary" dark :to="item.to">
          <v-list-item-icon><v-icon v-text="item.icon" /></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
          </v-list-item-content>
        </v-list-item>
        <!-- <base-item
          :hidden="true"
          :class="drawer ? 'pl-4' : ''"
          v-else
          :key="`item-${i}`"
          :item="item"
        /> -->
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>

    <!-- <template v-slot:append>
      <base-item
        :item="{
          title: $t('upgrade'),
          icon: 'mdi-package-up',
          to: '/upgrade',
        }"
      />
    </template> -->
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapState,
} from 'vuex'
import LocalStore from '../../../../lib/localStore'
export default {
  name: 'DashboardCoreDrawer',

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
    access: {
      type: Set,
      default: () => new Set([]),
    },
  },
  data: () => ({
    mini: true,
    items: [
      {
        icon: 'mdi-account-tie',
        title: 'Admin',
        to: '/admin',
        role: 'admin',
        access: 'admin',
      },
      {
        icon: 'mdi-domain',
        title: 'Company Settings',
        to: '/admin/settings',
        role: 'admin',
        access: 'admin',
      },
      {
        icon: 'mdi-view-dashboard',
        title: 'Dashboard V2',
        to: '/',
        access: 'dashboard',
      },
      {
        icon: 'mdi-account-box-multiple',
        title: 'Manage Consumer',
        to: '/consumers',
        access: 'consumers',
      },
      {
        icon: 'mdi-table-cog',
        title: 'Inventory',
        group: '',
        children: [
          { title: 'Transfer', to: '/inventories/transfer', access: 'store_transfers' },
          { title: 'Receive', to: '/inventories/transfer-receive', access: 'store_receives' },
          { title: 'Purchased', to: '/inventories/recieved', access: 'purchases' },
          { title: 'Cash Sales', to: '/inventories/sale', access: 'sales' },
          { title: 'Lost', to: '/inventories/lost', access: 'lost' },
          {
            title: 'Product Movement',
            to: '/inventories/breakdown',
            access: 'inventory_breakdown',
          },
          { title: 'Returned Products', to: '/inventories/returned-products', access: 'sales' },
        ],
      },
      {
        icon: 'mdi-currency-usd-off',
        title: 'Manage Expenses',
        to: '/expenses',
        access: 'expenses',
      },
      {
        icon: 'mdi-calendar-check',
        title: 'Manage Stock',
        to: '/stocks',
        access: 'stocks',
      },
      {
        icon: 'mdi-package',
        title: 'Whole Sales',
        to: '/whole-sales',
        access: 'whole_sales',
      },
      {
        icon: 'mdi-tag-multiple',
        title: 'Stock Brand Types',
        to: '/stock-brand-types',
        access: 'stock_brand_types',
      },
      {
        icon: 'mdi-briefcase-account-outline',
        title: 'Manage Supplier',
        to: '/suppliers',
        access: 'suppliers',
      },
      {
        icon: 'mdi-briefcase-account-outline',
        title: 'Store Balance',
        to: '/store-balances',
        access: 'store_balances',
      },
      {
        icon: 'mdi-warehouse',
        title: 'Inventory Monitoring',
        to: '/inventory-monitoring',
        access: 'inventory_monitoring',
      },
      {
        icon: 'mdi-package-down',
        title: 'Export',
        to: '/export',
        access: 'exports',
      },
      {
        icon: 'mdi-sale',
        title: 'Manage Promotions',
        to: '/promotions',
        access: 'promotions',
      },
      {
        icon: 'mdi-table-merge-cells',
        title: 'Promotion Stocks',
        to: '/promotion-stocks',
        access: ['promotions', 'stocks'],
      },
    ],
  }),
  created() {
    const localStore = new LocalStore()
    const createTransferInventoryRequestLocalData = localStore.get('createTransferInventoryRequest')
    this.$store.dispatch('appDrawer/setTransferUnsavedChanges', !!createTransferInventoryRequestLocalData?.unsavedChanges)
    const viewReceiveInventoryLocalData = localStore.get('viewReceiveTransferInventory')
    const receiveKeys = Object.keys(viewReceiveInventoryLocalData ?? {})
    this.$store.dispatch('appDrawer/setReceiveUnsavedChanges', receiveKeys.length)
    this.filterItems(this.access)
  },

  computed: {
    ...mapState({
      barColor: state => state.barColor,
      adminCode: state => state.auth.user.admin,
      barImage: state => state.barImage,
      saleTempList: state => state.saleInventory.tempList,
      recievedTempList: state => state.recievedInventory.tempList,
      lostTempList: state => state.lostInventory.tempList,
      storeId: state => state.settings.storeId,
      stores: state => state.branchLocation.list,
      user: state => state.auth.user,
      transferUnsavedChanges: state => state.appDrawer.transfer.unsavedChanges,
      receiveUnsavedChanges: state => state.appDrawer.receive.unsavedChanges,
    }),
    storeName() {
      return this.stores.find(e => e.id === this.storeId).name
    },
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(val) {
        this.$store.commit('SET_DRAWER', val)
      },
    },
    computedItems() {
      return this.items.map(this.mapItem)
    },
    profile() {
      return {
        avatar: true,
        title: this.$t('avatar'),
      }
    },
  },
  watch: {
    access(access) {
      this.filterItems(access)
    },
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title),
      }
    },
    /**
     * Description
     * @param {Set<string>} access
     */
    filterItems(access) {
      this.items = this.items.reduce((prev, next) => {
        const checkAccess = entry => {
          if (Array.isArray(entry.access)) {
            return entry.access.every(perm => access.has(perm))
          }
          return access.has(entry.access)
        }

        if (next.children) {
          const children = next.children.filter(child => checkAccess(child))
          if (children.length) {
            prev.push({ ...next, children })
          }
        } else if (checkAccess(next)) {
          prev.push(next)
        }

        return prev
      }, [])
    },
  },
}
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
<style lang="scss" scoped>
.colorless {
  background-color: rgba(10, 10, 10, 1)
}
</style>
